jQuery(document).ready(function($){
  $('.footer__block--links p.h4, .footer__block--text p.h4').click(function(){
    $(this).parents('.footer__block').toggleClass('open');
  });
  
  $('.cat-tab-nav-item').click(function(){
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    let tab = $(this).data('id');
    $(this).closest('.cat-tab-wrapper').find('.cat-tab-item').removeClass('active');
    $('#' + tab).addClass('active');
  }); 

  // Product Fake Description Function
  if ($( ".fake-description" ).length > 0){
    let detail = $( "#custom_detail" ).html();
    $("div.description_detail").append(detail);
  }

  $(document).on('click', '.drawer-filter-item-wrapper .checkbox-control', function(){
    $('#facets-drawer .close-filter-drawer').click();
  });

  $('.custom-card-variant-image').click(function(){
    let url = $(this).data('url');
    let img = $(this).data('image');
    let value = $(this).data('value');
    let parent = $(this).closest('.product-custom-card');
    parent.find('.custom-card-variant-image').removeClass('active');
    $(this).addClass('active');
    parent.find('.custom-card-main-mdeia img').attr('src', img);
    parent.find('.view-card-item a').attr('href', url);
    parent.find('.more-viariants a').attr('href', url);
    parent.find('.card-selected-color').text(value);
    
    
  });
    
  

  if ($('.lookbook-products-slider').length){
    $('.lookbook-products-slider').slick({
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 3,
      variableWidth: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 9000,
      arrows: false,
      responsive: [
        {
          breakpoint: 699,
          settings: {
            slidesToShow: 2,
            arrows: true,
          }
        }
      ]
    });
  }
});